import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { ContractorTransfer } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  id: number
  options?: Omit<UseQueryOptions<ContractorTransfer, Error>, 'queryKey' | 'queryFn'>
}

export const useContractorTransferRequest = ({ id, options }: RequestParams) => {
  const api = useApiInstance()

  return useQuery<ContractorTransfer, Error>(
    [Entities.ContractorTransfers, id],
    async () => {
      const { data } = await api.v1AdminContractorTransfersTransferIdGet(id)
      return data as unknown as ContractorTransfer
    },
    { ...options }
  )
}
